import isString from 'lodash/isString';
var INITIAL_MESSAGE = '[iFrameSizer]iFrameResizer0:8:false:false:32:true:true:null:taggedOrLowestElement:null:null:0:false:parent:scroll:body';
var IFRAME_URL = 'https://tools.financeads.net/baufinanzierungrechner.php?h=1&wf=38614&width=650&use_productgroups=1';
var helpers = {
    getIframeSrc: function (loanAmount, placementId) {
        var url = IFRAME_URL;
        if (typeof loanAmount !== 'undefined') {
            url += "&kreditbetrag=".concat(loanAmount);
        }
        if (typeof placementId !== 'undefined') {
            url += "&subid=".concat(placementId);
        }
        return url;
    },
    getInitialMessage: function () {
        return INITIAL_MESSAGE;
    },
    isResizeMessage: function (event) {
        var data = event.data, origin = event.origin;
        return (origin === 'https://tools.financeads.net' &&
            data &&
            isString(data) &&
            data.startsWith('[iFrameSizer]'));
    },
};
export default helpers;
